//@flow

import React from 'react';

type Props = {
  step: number,
  minValue: number,
  initialCount: number,
};

function useCounter(props: Props) {
  const { initialCount, step, minValue } = props;
  const [count, setCount] = React.useState(Number(initialCount));

  const increment = (): void => setCount(count + step);

  const decrement = (): void => (count > minValue ? setCount(count - step) : null);

  return { increment, decrement, count };
}

useCounter.defaultProps = {
  initialCount: 1,
  step: 1,
  minValue: 0,
};

export default useCounter;



// WEBPACK FOOTER //
// ./src/hooks/useCounter.js